//  frontend/src/components/layout/BackButton.js
import { useNavigate } from "react-router-dom";

export default function BackButton({ to = "/", label = "← Back" }) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(to)}
      style={{
        marginBottom: 24,

        padding: "12px 20px",

        borderRadius: 14,

        background: "rgba(255,255,255,0.08)",

        color: "#fff",

        border: "2px solid rgba(255,255,255,0.08)",

        cursor: "pointer",

        fontSize: 18,

        fontWeight: 800,

        transition: "0.18s",
      }}
    >
      {label}
    </button>
  );
}
